var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14Z",
    stroke: "currentColor",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.39998 6.13339C6.39605 5.82897 6.47557 5.52928 6.62993 5.26686C6.78428 5.00444 7.00757 4.78931 7.27555 4.64483C7.54353 4.50035 7.84597 4.43203 8.15004 4.44729C8.45411 4.46254 8.74819 4.5608 9.00036 4.73139C9.25253 4.90197 9.45316 5.13837 9.58046 5.41493C9.70777 5.69148 9.7569 5.99762 9.72251 6.30012C9.68812 6.60262 9.57152 6.88993 9.38539 7.13085C9.19925 7.37177 8.95067 7.5571 8.66665 7.66672C8.13331 7.93339 7.99998 8.33339 7.99998 8.86672",
    stroke: "currentColor",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99998 11.3333C8.22089 11.3333 8.39998 11.1542 8.39998 10.9333C8.39998 10.7124 8.22089 10.5333 7.99998 10.5333C7.77906 10.5333 7.59998 10.7124 7.59998 10.9333C7.59998 11.1542 7.77906 11.3333 7.99998 11.3333Z",
    stroke: "currentColor",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.aa2537e07b1c51081ca48ba6f6802b9e.svg";
export { ForwardRef as ReactComponent };